import React from 'react'

const EmailIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="emailGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(100, 180, 255, 1)" />
          <stop offset="100%" stopColor="rgba(60, 140, 220, 1)" />
        </linearGradient>
        <filter id="emailGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Envelope */}
      <rect 
        x="3" 
        y="5" 
        width="18" 
        height="14" 
        rx="2"
        stroke="url(#emailGradient)"
        strokeWidth="2"
        fill="none"
        filter="url(#emailGlow)"
      />
      
      {/* Envelope flap */}
      <path 
        d="M3 7l9 6 9-6"
        stroke="url(#emailGradient)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  )
}

export default EmailIcon
